import React from 'react';

import lion   from './img/icon-pt4-black-lion.png';
import scales from './img/icon-pt4-trading-post.png';

import { i18n } from '../../i18n';

import SectionHeader from '../../section-header';
import ModalImage    from '../../modal-image';
import Paras         from '../../paras';
import Screenshot    from '../../screenshot';

import * as css from './index.module.css';

const prefix = 'part4.yi';

export default function YourInventory() {
    return (
        <div>
            <SectionHeader name="your-inventory" />

            <div className={css.section}>
                <div className={css.cols}>
                    <div className={css.col0}>
                        <p>{i18n(`${prefix}.para.0`, { doReplace : true })}</p>
                        <ul>
                            <li>{i18n(`${prefix}.list.0`)}</li>
                            <li>{i18n(`${prefix}.list.1`)}</li>
                            <li>{i18n(`${prefix}.list.2`)}</li>
                        </ul>
                    </div>

                    <div>
                        <ModalImage path={`${prefix}.modal.0`}>
                            <Screenshot path={`${prefix}.img.0`} />
                        </ModalImage>
                    </div>
                </div>

                <div className={css.cols}>
                    <div className={css.col0}>
                        <p>{i18n(`${prefix}.para2.header`)}</p>

                        <div className={css.iconWrap}>
                            <img src={lion} />
                            <p>{i18n(`${prefix}.para2.0`, { doReplace : true })}</p>
                        </div>

                        <div className={css.iconWrap}>
                            <img src={scales} />
                            <p>{i18n(`${prefix}.para2.1`)}</p>
                        </div>

                        <p>{i18n(`${prefix}.para2.2`)}</p>
                    </div>

                    <div>
                        <ModalImage path={`${prefix}.modal.1`}>
                            <Screenshot path={`${prefix}.img.1`} />
                        </ModalImage>
                    </div>
                </div>

                <div className={css.gathering}>
                    <div className={css.col0}>
                        <h3>{i18n(`${prefix}.g.header`)}</h3>
                        <Paras path={`${prefix}.g.para`} />
                    </div>

                    <div className={css.gatheringImg}>
                        <ModalImage path={`${prefix}.g.modal.0`}>
                            <Screenshot path={`${prefix}.g.img.0`} />
                        </ModalImage>
                        <ModalImage path={`${prefix}.g.modal.1`}>
                            <Screenshot path={`${prefix}.g.img.1`} />
                        </ModalImage>
                    </div>
                </div>
            </div>
        </div>
    );
}

